import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import DataTable, { defaultThemes } from "react-data-table-component";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { Link } from "react-router-dom";
const RozhanaDataTable = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            d_dataRozhana,
            D_gotowaslrentsearch,
            D_gotowaslparasearch,
            D_gotowaslGaranawasearch
          } = value;
          const datas = d_dataRozhana.map((el) => {
            return {
              date: (
                <Time
                  value={el.barwar}
                  format="YYYY-MM-DD"
                  style={{ color: "black" }}
                />
              ),
              code: (
                <td
                  className={` fk ${
                    el.jorefroshtn == "فرۆشتنی ڕاستەوخۆ" ? "bg-danger" : ""
                  }`}
                >
                  {el.zh_wakil}
                </td>
              ),
              paraymawa: el.paraymawa,
              dashkan: (
                <NumberFormat
                  value={el.kmkrdnawa}
                  thousandSeparator={true}
                  displayType="text"
                />
              ),
              draw: (
                <td
                  className="fk"
                  className={`${
                    el.joripara == "دۆلار" ? "dark-green" : "dark-red"
                  }`}
                >
                  {el.joripara}
                </td>
              ),
              koywasl: el.koywasl,
              name: el.nawi_wakil,
              jula: (
                <td
                  className="fk"
                  style={{
                    color: `${
                      el.jwlla == "گەڕانەوەی قەرز"
                        ? " #0000b3"
                        : el.jwlla == "گەڕانەوەی کاڵا"
                        ? " #cc6600"
                        : ""
                    }`
                  }}
                >
                  {el.jwlla}
                </td>
              ),
              wasl: (
                <td
                  className="fk"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    el.jwlla == "فرۆشتن"
                      ? D_gotowaslrentsearch(e, el.code)
                      : el.jwlla == "گەڕانەوەی قەرز"
                      ? D_gotowaslparasearch(e, el.code)
                      : D_gotowaslGaranawasearch(e, el.code);
                  }}
                >
                  <Link
                    to={`${
                      el.jwlla == "فرۆشتن"
                        ? "/ipad-rent"
                        : el.jwlla == "گەڕانەوەی قەرز"
                        ? "/take-money"
                        : "/ipad-rozhana"
                    }`}
                  >
                    {el.code}
                  </Link>
                </td>
              ),
              paraydraw: el.paraydraw
            };
          });
          const columns = [
            {
              name: "وکیل",
              selector: "code",
              sortable: true,
              center: true
            },
            {
              name: "ناوی وەکیل",
              cell: (row) => (
                <span className="f4 font-weight-bolder">{row.name}</span>
              ),
              sortable: true,
              center: true
            },
            {
              name: "پارەی ماوە",
              cell: (row) => (
                <span className="bg-danger text-white">
                  <NumberFormat
                    className="f4"
                    value={row.paraymawa}
                    thousandSeparator={true}
                    displayType="text"
                  />
                </span>
              ),
              sortable: true
            },
            {
              name: "پارەی دراو",
              cell: (row) => (
                <span className="bg-success text-white">
                  <NumberFormat
                    className="f4"
                    value={row.paraydraw}
                    thousandSeparator={true}
                    displayType="text"
                  />
                </span>
              ),
              sortable: true,
              center: true
            },
            {
              name: "داشکان",
              selector: "dashkan",
              sortable: true,
              center: true
            },
            {
              name: "دراو",
              selector: "draw",
              sortable: true
            },
            {
              name: "کۆی پسوولە",
              cell: (row) => (
                <span>
                  <NumberFormat
                    className="f4 font-weight-bolder"
                    value={row.koywasl}
                    thousandSeparator={true}
                    displayType="text"
                  />
                </span>
              ),
              sortable: true
            },
            {
              name: "جوولە",
              selector: "jula",
              sortable: true
            },
            {
              name: "بەروار",
              selector: "date",
              sortable: true
            },
            {
              name: "پسولە",
              selector: "wasl",
              sortable: true,
              center: true
            }
          ];

          const customStyles = {
            header: {
              style: {
                minHeight: "56px",
                background: "#2C3539"
              }
            },
            headRow: {
              style: {
                borderTopStyle: "solid",
                borderTopWidth: "1px",
                borderTopColor: defaultThemes.default.divider.default,
                background: "#2C3539"
              }
            },
            headCells: {
              style: {
                "&:not(:last-of-type)": {
                  borderRightStyle: "solid",
                  borderRightWidth: "1px",
                  borderRightColor: defaultThemes.default.divider.default
                },
                color: "#f0ad4e"
              }
            },
            cells: {
              style: {
                "&:not(:last-of-type)": {
                  borderRightStyle: "solid",
                  borderRightWidth: "1px",
                  borderRightColor: defaultThemes.default.divider.default
                },
                hover: "blue"
              }
            }
          };

          return (
            <>
              <div className="card-header p-1 border-bottom border-warning">
                <DataTable
                  columns={columns}
                  data={datas}
                  pagination="true"
                  noDataComponent={"هیچ کاڵایەک نیە"}
                  className="fk f1"
                  customStyles={customStyles}
                  highlightOnHover={true}
                />
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default RozhanaDataTable;
